"use client";

import {
  dispatch,
  TOAST_REMOVE_DELAY,
  Toast as ToastType,
  useToast,
} from "../hooks/use-toast";
import CheckCircleIcon from "./svg/CheckCircleIcon";
import CloseCircleIcon from "./svg/CloseCircleIcon";
import {
  Toast,
  ToastProvider,
  ToastTitle,
  ToastViewport
} from "./toast";

export function Toaster() {
  const { toasts } = useToast();

  return (
    <div className="pointer-events-none" tabIndex={-1}>
      <ToastProvider duration={TOAST_REMOVE_DELAY}>
        {toasts.map(function (toast: ToastType) {
          const { id, title, variant } = toast;
          return (
            <Toast
              key={id}
              {...toast}
              onPause={() => {
                setTimeout(() => {
                  dispatch({ type: "DISMISS_TOAST", toastId: id });
                }, 2000);
              }}
            >
              <div className="flex items-center gap-3 2xl:gap-4">
                <div className="flex-shrink-0">
                  {variant === "success" ? (
                    <CheckCircleIcon className="size-5 2xl:size-6 text-success" />
                  ) : variant === "destructive" ? (
                    <CloseCircleIcon className="size-5 2xl:size-6 text-error" />
                  ) : (
                    <></>
                  )}
                </div>
                <div className="flex-1 min-w-0">
                  {title && <ToastTitle className="text-sm 2xl:text-lg leading-none tracking-tight text-primary">{title}</ToastTitle>}
                </div>
              </div>
            </Toast>
          );
        })}
        <ToastViewport />
      </ToastProvider>
    </div>
  );
}
